__turbopack_context__.v({
  "isActive": "why-signoz-module__lCDQ7W__isActive",
  "isDone": "why-signoz-module__lCDQ7W__isDone",
  "item": "why-signoz-module__lCDQ7W__item",
  "itemDesc": "why-signoz-module__lCDQ7W__itemDesc",
  "itemProgress": "why-signoz-module__lCDQ7W__itemProgress",
  "itemTitle": "why-signoz-module__lCDQ7W__itemTitle",
  "reveal": "why-signoz-module__lCDQ7W__reveal",
  "revealCta": "why-signoz-module__lCDQ7W__revealCta",
});
